import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { compose, lifecycle } from 'recompose';
import { withToggle } from '../../HOC/withToggle';
import { connect } from 'react-redux';
//styles
import { MenuButton, HamburgerContainer, HamburgerButton, DropDownBox } from './style';
// components
import { ProfileAvatar } from '../ProfileAvatar/ProfileAvatar';

//ui
import { Text } from '../../UI/Text';
import { Button, RedTextButton } from '../../UI/Button';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { Delegate, ClickContextConsumer } from '../../Containers/Delegate/Delegate';
import { generateSlugLink } from '../../../Utils';
import { config } from '../../../Configurations';
import { HoverableLink, Row } from '../../Layouts';
import { Icon } from '../Icons/Icons';

const mapStateToProps = ({ user }) => ({
    name: user.currentUser.fullName,
    type: user.currentUser.type,
});

const DisplayGymTab = ({ type, children }) => {
    if (type && type.toLowerCase() === 'gym') {
        return <div>{children}</div>;
    }
    return null;
};

const DropdownButton = ({ children, onClick }) => (
    <div onClick={onClick}>
        <Button padding={'0 6px 0 0'} scratch>
            <Row align={'center'}>{children}</Row>
        </Button>
    </div>
);

let MainMenuHamburger = ({ onLogout, name, hide, toggle, onToggle, type }) => {
    const id = handleLoginService.getUserId();
    const link = `/${generateSlugLink({ name, id })}`;

    return (
        <Delegate.Click onAction={hide}>
            <MenuButton onClick={toggle}>Menu</MenuButton>
            <HamburgerContainer isActive={onToggle}>
                <Link to={link}>
                    <HamburgerButton>
                        <Text>Profile</Text>
                    </HamburgerButton>
                </Link>

                <Link to={`${link}/planned`}>
                    <HamburgerButton>
                        <Text>Plans</Text>
                    </HamburgerButton>
                </Link>

                <Link to={'/planner'}>
                    <HamburgerButton>
                        <Text>Plan Workout</Text>
                    </HamburgerButton>
                </Link>

                <DisplayGymTab>
                    <Link to={'/check-in'}>
                        <HamburgerButton>
                            <Text>Check In</Text>
                        </HamburgerButton>
                    </Link>
                </DisplayGymTab>

                <HamburgerButton onClick={onLogout}>
                    <Text>Log out</Text>
                </HamburgerButton>
            </HamburgerContainer>
        </Delegate.Click>
    );
};

// TODO: refactor (make as reusable)
let WorkoutPlanExercisesActionsKebab = ({ onToggle, toggle, hide, onDelete, onDuplicate, onMoveUp, onMoveDown }) => {
    const performActionAndHide = action => {
        action();
        hide();
    };

    return (
        <Delegate.Click onAction={hide}>
            <div style={{ position: 'relative' }}>
                <div onClick={toggle} style={{ color: 'white', cursor: 'pointer', opacity: '0.8' }}>
                    <i className="fas fa-ellipsis-h" />
                </div>

                {onToggle && (
                    <DropDownBox>
                        <DropdownButton onClick={() => performActionAndHide(onDelete)}>
                            <Icon.Box size={'18x18'}>
                                <Icon.Delete />
                            </Icon.Box>
                            <Text weight={200} color={'lightGrey'} left>
                                Delete
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={() => performActionAndHide(onDuplicate)}>
                            <Icon.Box size={'18x18'}>
                                <Icon.Copy />
                            </Icon.Box>
                            <Text weight={200} color={'lightGrey'} left>
                                Duplicate
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={() => performActionAndHide(onMoveUp)}>
                            <Icon.Box size={'18x18'}>
                                <Icon.ArrowUp />
                            </Icon.Box>
                            <Text weight={200} color={'lightGrey'} left>
                                Move Up
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={() => performActionAndHide(onMoveDown)}>
                            <Icon.Box size={'18x18'}>
                                <Icon.ArrowDown />
                            </Icon.Box>
                            <Text weight={200} color={'lightGrey'} left>
                                Move Down
                            </Text>
                        </DropdownButton>
                    </DropDownBox>
                )}
            </div>
        </Delegate.Click>
    );
};

// TODO: refactor (make as reusable)
let GymTvCardKebab = ({ onToggle, toggle, hide, onPlay, onEdit, onDuplicate, onDelete }) => {
    const performActionAndHide = (event, action) => {
        event.stopPropagation();
        action();
        hide();
    };

    return (
        <Delegate.Click onAction={hide}>
            <div style={{ position: 'relative' }}>
                <div onClick={toggle} style={{ color: 'white', cursor: 'pointer', opacity: '0.8' }}>
                    <i className="fas fa-ellipsis-h" />
                </div>

                {onToggle && (
                    <DropDownBox>
                        <DropdownButton onClick={event => performActionAndHide(event, onPlay)}>
                            <Text weight={200} color={'lightGrey'} left>
                                Play
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={event => performActionAndHide(event, onEdit)}>
                            <Text weight={200} color={'lightGrey'} left>
                                Edit
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={event => performActionAndHide(event, onDuplicate)}>
                            <Text weight={200} color={'lightGrey'} left>
                                Duplicate
                            </Text>
                        </DropdownButton>

                        <DropdownButton onClick={event => performActionAndHide(event, onDelete)}>
                            <Text weight={200} color={'lightGrey'} left>
                                Delete
                            </Text>
                        </DropdownButton>
                    </DropDownBox>
                )}
            </div>
        </Delegate.Click>
    );
};

function Menu({ onLogout, profilePhoto, onToggle, toggle, hide, type, user, ...props }) {
    const id = handleLoginService.getUserId();
    const name = handleLoginService.getFullName();

    return (
        <Delegate.Click onAction={hide}>
            <div style={{ position: 'relative' }}>
                <div style={{ cursor: 'pointer ' }} onClick={toggle}>
                    <ProfileAvatar src={`${config.baseUrl}${profilePhoto}`} />
                </div>
                {onToggle && (
                    <DropDownBox>
                        <DisplayGymTab type={type}>
                            <HoverableLink to={`/check-in`} target={'_blank'}>
                                <Text color={'lightGrey'} left>
                                    Check in
                                </Text>
                            </HoverableLink>
                        </DisplayGymTab>
                        <DisplayGymTab type={type}>
                            <HoverableLink to={`/gym-admin`} target={'_blank'}>
                                <Text color={'lightGrey'} left>
                                    Gym admin
                                </Text>
                            </HoverableLink>
                        </DisplayGymTab>
                        <div>
                            <HoverableLink
                                to={`/${generateSlugLink({
                                    name,
                                    id,
                                })}`}
                            >
                                <Text color={'lightGrey'} left>
                                    View Profile
                                </Text>
                            </HoverableLink>
                        </div>
                        <div>
                            <Button
                                scratch
                                padding={'0'}
                                onClick={e => {
                                    onLogout();
                                    hide();
                                }}
                            >
                                <Text color={'lightGrey'} left>
                                    Log Out
                                </Text>
                            </Button>
                        </div>
                    </DropDownBox>
                )}
            </div>
        </Delegate.Click>
    );
}

const DropdownWorkoutDisplay = ({ onLogout, profilePhoto, onToggle, toggle, hide, type, user, links, ...props }) => {
    return (
        <Delegate.Click onAction={hide}>
            <div style={{ position: 'relative' }}>
                <RedTextButton onClick={toggle}>Start live class</RedTextButton>

                {onToggle && (
                    <DropDownBox>
                        <div>
                            <Link target={'_blank'} to={links[0]}>
                                <Text weight={200} color={'lightGrey'} left>
                                    Heart rate & calories
                                </Text>
                            </Link>
                        </div>
                        <div>
                            <Link target={'_blank'} to={links[1]}>
                                <Text weight={200} color={'lightGrey'} left>
                                    Workout programme
                                </Text>
                            </Link>
                        </div>
                        <div>
                            <Link target={'_blank'} to={links[2]}>
                                <Text weight={200} color={'lightGrey'} left>
                                    Repeat workout
                                </Text>
                            </Link>
                        </div>
                    </DropDownBox>
                )}
            </div>
        </Delegate.Click>
    );
};

class ClassRowDropDown extends PureComponent {
    render() {
        const { openEditOccurance, openEditSeries, toggle, hide, onToggle, children } = this.props;
        return (
            <Delegate.Click onAction={hide}>
                <div ref={node => (this.box = node)} style={{ position: 'relative', height: '100%' }}>
                    {React.Children.map(children, child => React.cloneElement(child, { onClick: toggle }))}

                    {onToggle && (
                        <ClickContextConsumer>
                            {/* <DropDownBox> */}
                            <div onClick={openEditSeries}>
                                <Text cursor={'pointer'} medium color={'lightGrey'} left>
                                    Edit series
                                </Text>
                            </div>
                            <div onClick={openEditOccurance}>
                                <Text cursor={'pointer'} medium color={'lightGrey'} left>
                                    Edit occurance
                                </Text>
                            </div>
                            {/* </DropDownBox> */}
                        </ClickContextConsumer>
                    )}
                </div>
            </Delegate.Click>
        );
    }
}

class ProfileSettings extends React.Component {
    state = {
        isDeleteButtonPressed: false,
    };

    deleteButtonClick = () => this.setState({ isDeleteButtonPressed: true });
    confirmDeletion = () => {
        this.props.onAccountDelete();
        this.props.toggle();
        this.setState({ isDeleteButtonPressed: false });
    };
    declineDeletion = () => {
        this.props.toggle();
        this.setState({ isDeleteButtonPressed: false });
    };

    render() {
        const { onToggle, toggle, hide } = this.props;
        return (
            <Delegate.Click onAction={hide}>
                <div style={{ position: 'relative' }}>
                    <Icon.Box onClick={toggle} size={'24x24'} opacity={0.75} cursor={'pointer'}>
                        <Icon.Settings />
                    </Icon.Box>

                    {onToggle && (
                        <DropDownBox>
                            {this.state.isDeleteButtonPressed ? (
                                <React.Fragment>
                                    <section>
                                        <Text alignCenter={true} weight={200} color={'lightGrey'} left>
                                            Are you sure? This cannot be undone
                                        </Text>
                                    </section>
                                    <div onClick={this.confirmDeletion}>
                                        <Text weight={200} color={'lightGrey'} left>
                                            Yes
                                        </Text>
                                    </div>
                                    <div onClick={this.declineDeletion}>
                                        <Text weight={200} color={'lightGrey'} left>
                                            No
                                        </Text>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <div onClick={this.deleteButtonClick}>
                                    <Text weight={200} color={'lightGrey'} left>
                                        Delete Account
                                    </Text>
                                </div>
                            )}
                        </DropDownBox>
                    )}
                </div>
            </Delegate.Click>
        );
    }
}

export const ClassDropDown = compose(withToggle)(ClassRowDropDown);
export const ProfileSettingsDropDown = compose(withToggle)(ProfileSettings);
export const WorkoutDisplayDropdown = compose(withToggle)(DropdownWorkoutDisplay);

export const DropDownMenu = compose(
    withToggle,
    withRouter,
    connect(mapStateToProps),
    lifecycle({
        componentDidUpdate(prevProps, prevState) {
            if (prevProps.location.key !== this.props.location.key && this.props.onToggle) {
                this.props.hide();
            }
        },
    }),
)(Menu);

export const DropDownHamburger = compose(
    withToggle,
    withRouter,
    connect(mapStateToProps),
    lifecycle({
        componentDidUpdate(prevProps, prevState) {
            if (prevProps.location.key !== this.props.location.key && this.props.onToggle) {
                this.props.hide();
            }
        },
    }),
)(MainMenuHamburger);

export const WorkoutPlanExercisesKebab = compose(withToggle)(WorkoutPlanExercisesActionsKebab);
export const GymTvCardActionsKebab = compose(withToggle)(GymTvCardKebab);



// WEBPACK FOOTER //
// ./src/UI/Components/Dropdowns/index.js